import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";

const ToBagButton = ({ className, buttonText, onClick, isDisabled }) => (
  <button
    className={classnames(className, styles.toBagButton)}
    onClick={onClick}
    disabled={isDisabled}
  >
    {buttonText}
  </button>
);

ToBagButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired
};

export default ToBagButton;
